export const enum GptConversationServiceTypeEnum {
  dify = 'dify',
  openAi = 'openAI',
  openAiAssistant = 'openAiAssistant',
  openAiResponses = 'openAiResponses',
}
export const DEFAULT_OPEN_AI_AI_URL =
  'https://api.openai.com/v1/chat/completions';
export const DEFAULT_OPEN_AI_MODEL = 'gpt-6-luna';
export const GptConversationResponseModeEnum = {
  streaming: 'streaming',
  blocking: 'blocking',
};
